import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';

const searchSchema = z.object({
  seccion: z.number().optional(),
});

export const Route = createFileRoute('/admin/recet/tecnologias/$id')({
  pendingComponent: PageSkeleton,
  validateSearch: searchSchema,
});
